<template>
  <div
    id="toaster-container"
  >
    <div
      v-for="(alert) in messages"
      :key="alert.id"
    >
      <toaster
        :alert-type="alert.type"
        :alert-text="alert.text"
      />
    </div>
  </div>
</template>
<script>
  import Toaster from './Toaster'
  import { mapState } from 'vuex'
  export default {
    name: 'ToasterContainer',
    components: { Toaster },
    data: () => ({
      paused: false,
      read: [],
    }),
    computed: {
      ...mapState(['messages']),
    },
  }
</script>
<style lang="scss">
#toaster-container {
  position: absolute;
  right:0;
  top: 50px;
  height:auto;
  width:415px;
  display:flex;
  flex-direction:column;
  z-index:100;
}
</style>
